import React from 'react';
import { getSectionDivider } from '../../utils/SectionDividerUtil';
import styles from './SectionDivider.scss';

interface SectionDividerProps {
    itemId: string;
    prevItemId?: string;
}

export const SectionDivider = ({ itemId, prevItemId }: SectionDividerProps) => {
    const sectionDivider = getSectionDivider(itemId, prevItemId);

    return sectionDivider ? <div className={styles.divider}>{sectionDivider}</div> : null;
};
